// Business-facing dates render in America/Panama (CLIMARA Closeout FIX 13).
// UAT A8 (2026-08-09): formats must be UNAMBIGUOUS in both languages —
// Spanish uses "23 ago 2026", English "Aug 23, 2026". Bare dates
// (YYYY-MM-DD, no time component) are calendar dates: never timezone-shifted.
export const BUSINESS_TZ = 'America/Panama';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function toDate(iso) {
  // Anchor bare dates at 12:00 UTC so the Panama (UTC-5) render keeps the day.
  return DATE_ONLY.test(String(iso)) ? new Date(`${iso}T12:00:00Z`) : new Date(iso);
}

export function bizDate(iso, lang = 'es') {
  if (!iso) return '—';
  try {
    return toDate(iso).toLocaleDateString(
      (lang || 'es').startsWith('es') ? 'es' : 'en-US',
      { timeZone: BUSINESS_TZ, year: 'numeric', month: 'short', day: 'numeric' },
    );
  } catch {
    return String(iso).slice(0, 10);
  }
}

export function bizDateTime(iso, lang = 'es') {
  if (!iso) return '—';
  try {
    return toDate(iso).toLocaleString(
      (lang || 'es').startsWith('es') ? 'es' : 'en-US',
      { timeZone: BUSINESS_TZ, year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' },
    );
  } catch {
    return String(iso).slice(0, 16);
  }
}

// Locale-aware drop-in for bare toLocaleDateString()/toLocaleString() calls
// (platform ES sweep 2026-06): presentation-only, stored timestamps untouched.
import i18next from 'i18next';
export function getUiLocale() {
  // 'es' (not 'es-PA'): CLDR es-PA numeric dates are MM/dd like en-US,
  // while generic 'es' yields the expected dd/mm presentation.
  return (i18next.language || 'es').startsWith('es') ? 'es' : 'en-US';
}
